import { render, staticRenderFns } from "./bodyRightCenter.vue?vue&type=template&id=ae61b806&scoped=true"
import script from "./bodyRightCenter.vue?vue&type=script&lang=js"
export * from "./bodyRightCenter.vue?vue&type=script&lang=js"
import style0 from "./bodyRightCenter.vue?vue&type=style&index=0&id=ae61b806&prod&lang=scss&scoped=true"
import style1 from "./bodyRightCenter.vue?vue&type=style&index=1&id=ae61b806&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae61b806",
  null
  
)

export default component.exports